<template>
  <EntityCustomFields
    :items="items"
    :entityId="this.$route.params.categoryId"
    :entity="'categories'"
    @onRefresh="onRefresh"/>
</template>

<script>
import EntityCustomFields from '@/components/V2/EntityCustomFields/EntityCustomFields.vue';

export default {
  name: 'CategoryDetailsCustomFields',

  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  components: {
    EntityCustomFields,
  },

  computed: {},

  data () {
    return {};
  },

  methods: {
    onRefresh () {
      this.$emit('refresh');
    },
  },
};
</script>
